import { MenuItem } from "../../Types/Layout/SidebarType";

export const FoodMenuList: MenuItem[] = [
  {
    title: "General",
    lanClass: "lan-1",
    Items: [
      {
        title: "Dashboard",
        id: 1,
        icon: "home",
        type: "link",
        lanClass: "lan-3",
        path: `${process.env.PUBLIC_URL}/dashboard/default`,
      },
    ],
  },
  {
    title: "Applications",
    lanClass: "lan-8",
    Items: [
      {
        title: "Food",
        id: 6,
        icon: "ecommerce",
        type: "sub",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/food/food_order`, type: "link", title: "Food Order" },
          { path: `${process.env.PUBLIC_URL}/food/all_food_order`, type: "link", title: "All Food Order" },
        ],
      },
    ],
  },
];
